// extracted by mini-css-extract-plugin
export default {"NotificationModel":"notification-model_NotificationModel__4-gt-"};